<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
      <el-row>
        <el-col :span="4" class="lg">
          <div class="grid-content bg-purple lefttitle">
            <div class="">
              <ul>
                <li v-for="category in merchantCategorys" :key="category.id" class="merchantcategory" @click="select(category)">
                  <span class="merchantCategoryDetails" :class="[category.selected =='1'?'selected':'']">{{category.label}}</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="18" >
          <div class="grid-content bg-purple-light">
            <div class="brandsNavBar">
              <div class="brandsToggle">
                
                <el-select class="countryToggle" v-model="country" clearable placeholder="请选择地区" @change="changeCountry">
                  <el-option
                    v-for="item in COUNTRIES"
                    :key="item.value"
                    :label="item.name+'('+item.value+')'"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div class="orderToggle">
                  <div style="display:inline-block;vertical-align: top;">支持下单的商家</div>
                  <el-switch
                    @change="changeOrder"
                    v-model="isSupport"
                    active-color="#333333"
                    inactive-color="#cccccc">
                  </el-switch>
                </div>
              </div>
              <h2 class="brandsTitle lg">{{title}} </h2>
              <ul class="brandsNavUl">
                <li v-for="item in brandsDetails" :key="item.id" class="brandsNavLl" @click ="scroll('#'+item.tag)">
                  <a class="brandsNavElement" href="javascript:void(0)" :class="[item.contant.length==0?'prohibit':'']">{{ item.tag }}</a>
                </li>
              </ul>
            </div>
            <div>
              <div class="brandsDetail">
                <dd v-if="loading" class="text-center">
                  <Loading></Loading>
                </dd>
                <ul class="brandsDetailUl">
                  <li v-for="item in brandsDetails" class="brandsDetailLi" :id="item.tag" v-if="item.contant.length>0">
                    <div class="tagdiv">
                      <a class="detailtag" > {{item.tag}}</a><div @click="goTop()" class="goTop">↑</div></br>
                    </div>
                    <div class="brandsDetailElement" v-for="de in item.contant">
                      <a href='javascript:void(0);' class="brands"  style=" color: #666 !important; font-size: 15px !important;    letter-spacing: 0.1px !important; line-height: 19px !important;"><div @click="goGoodList(de)">{{de.name}}</div></a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
  import hd from '../../components/Header'
  import ft from '../../components/Footer'
  import api from '../../services/api.js'
  import { COUNTRIES } from '../../services/constant'
  import mobilefooter from '../../components/mobilefooter'
  import Loading from '../../components/Loading'
import GlobalDialogs from '../../components/GlobalDialogs'
  let _ = require('lodash')
  let $ = require('jQuery')


  export default {
    name: 'Brands',
    components: {
      hd: hd,
      ft: ft,
      mobilefooter: mobilefooter,
      Loading: Loading,
    GlobalDialogs: GlobalDialogs
    },

    data () {
      return {
        loading: true,
        mobiletype: false,
        screenWidth: document.body.clientWidth,
        COUNTRIES: COUNTRIES,
        country: null,
        isSupport: false,
        support_order: '0',
        items: [],
        merchantCategorys:  [
        {value: '全部商家', label: '全部商家',selected:'1'},
        {value: '综合百货', label: '综合百货',selected:'0'},
        {value: '美妆护肤', label: '美妆护肤',selected:'0'},
        {value: '服饰鞋包', label: '服饰鞋包',selected:'0'},
        {value: '食品保健', label: '食品保健',selected:'0'},
        {value: '母婴玩具', label: '母婴玩具',selected:'0'},
        {value: '家居日用', label: '家居日用',selected:'0'},
        {value: '珠宝手表', label: '珠宝手表',selected:'0'},
        {value: '电子数码', label: '电子数码',selected:'0'},
        {value: '酒店机票', label: '酒店机票',selected:'0'},
        {value: '其他', label: '其他商家'}
        ],
        brandsDetails: [],
        title: '全部商家' ,
        category: '全部商家'//类别
      }
    },
      created() {
        if (document.body.clientWidth < 1024) {
          this.mobiletype = true
        }
        this.getMerchant()
      },
      mounted() {
        const that = this
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
          })()

        }
      },
      methods: {
        async getMerchant () {
          this.loading = true
          let res = await api.getBusinessListbyalphabet(this)
          if(res.body.status == 'ok') {
            this.loading = false
            let info = res.body.result
            let brandsDetails = []
            let items = []
            let id = 0
            _.each(info,(item,index) => {
              let brands = {}
              let ids = {}
              if(index == ''){
                brands.tag = '#'
                ids.tag = '#'
              }else{
                brands.tag = index
                ids.tag = index
              }
              brands.id = id
              brands.contant = []
              if(this.category == '全部商家' && this.support_order == '0' && !this.country){
                //默认显示全部商家，无筛选条件
                _.each(item,list => {
                  if(list.verified == '1'){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category == '全部商家' && this.support_order == '1' && !this.country){
                //全部商家中只显示支持下单商家
                _.each(item,list => {
                  if(list.verified == '1' && list.support_order == '1'){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category == '全部商家' && this.support_order == '0' && this.country){
                //全部商家中显示对应的国家筛选条件
                _.each(item,list => {
                  if(list.verified == '1' && list.country == this.country){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category == '全部商家' && this.support_order == '1' && this.country){
                //全部商家中显示对应的国家筛选条件并且支持下单
                _.each(item,list => {
                  if(list.verified == '1' && list.country == this.country && list.support_order == '1'){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category != '全部商家' && this.support_order == '0' && !this.country){
                //显示对应的category类别商家
                _.each(item,list => {
                  if(list.verified == '1' && list.product_type == this.category){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category != '全部商家' && this.support_order == '0' && this.country){
                //显示对应的category类别商家和对应的国家筛选
                _.each(item,list => {
                  if(list.verified == '1' && list.product_type == this.category && list.country == this.country){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category != '全部商家' && this.support_order == '1' && !this.country){
                //显示对应的category类别商家并且支持下单
                _.each(item,list => {
                  if(list.verified == '1' && list.product_type == this.category && list.support_order == '1'){
                    brands.contant.push(list)
                  }
                })
              }else if(this.category != '全部商家' && this.support_order == '1' && this.country){
                //显示对应的category类别商家对应的国家筛选条件并且支持下单
                _.each(item,list => {
                  if(list.verified == '1' && list.product_type == this.category && list.support_order == '1' && list.country == this.country){
                    brands.contant.push(list)
                  }
                })
              }

              ids.id = id
              brandsDetails.push(brands)
              items.push(ids)
              id ++
            })
            this.brandsDetails = brandsDetails
            this.items = items
            console.log(this.brandsDetails)
          }
        },
        scroll: function (selector){
          let clientWidth = document.body.clientWidth
          if(selector == '##'){
            selector = '#Z'
            let select = this.$el.querySelector(selector)
            if(clientWidth < 769){
              $(document).scrollTop(select.offsetTop + select.offsetHeight + 60)
            }else{
              $(document).scrollTop(select.offsetTop + select.offsetHeight + 110)
              // document.documentElement.scrollTop = select.offsetTop + select.offsetHeight + 110
            }
            return
          }
          let anchor = this.$el.querySelector(selector)
          if(clientWidth < 769){
            $(document).scrollTop(anchor.offsetTop + 60)
          }else{
            $(document).scrollTop(anchor.offsetTop + 110)
            // document.documentElement.scrollTop = anchor.offsetTop + 110
          }
        },
        select (category) {
          this.title = category.label
          this.category = category.value
          _.each(this.merchantCategorys,item => {
            if(item.value == category.value){
              item.selected = '1'
            }else{
              item.selected = '0'
            }
          })
          this.getMerchant()
        },
        changeCountry () {
          this.getMerchant()
        },
        changeOrder () {
          if(this.isSupport){
            this.support_order = '1'
          }else{
            this.support_order = '0'
          }
          this.getMerchant()
        },
        goTop () {
          let clientWidth = document.body.clientWidth
          console.log(clientWidth)
          if(clientWidth < 769){
            $(document).scrollTop(0)
          }else{
            $(document).scrollTop(0)
          }
        },
        goGoodList (data) {
          this.$router.push({name: 'Merchant', params: {id: data.tag}})
        },
      },
      
      watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        }
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contioner {
    margin: 0 auto 60px;;
    margin-top: 180px;
    padding-left: 10%;
    padding-right: 20px;
  }
  .lg {
    display: block;
  }
  .sm {
    display: none;
  }

  .lefttitle {
    padding-left: 40px;
  }

  .brandsNavBar {
    /*padding-left: 30px;*/
    position: relative;
    max-width: 960px;
  }
  .brandsToggle {
    position: absolute;
    right: 30px;
    width: 350px;

    .orderToggle {
      float: right;
      width: 49%;
      vertical-align: top;
      display: inline-block;
      cursor: pointer;
      height: 40px;
      text-align: center;
      border-radius: 4px;
      background-color: #fff;
      padding: 10px 0;
      font-size: 14px;
      line-height: 19px;
    }
    .countryToggle {
      width: 50%;
      float: left;
    }
  }
  .brandsTitle {
    font-size: 26px !important;
    letter-spacing: 0.5px !important;
    line-height: 1.62 !important;
    padding-bottom: 30px !important;
    width: 100% !important;
    display: block !important;
    color: #333 !important;
  }

  .brandsTitle:after {
    margin-left: -105px !important;
    margin-top: 55px;
    content: '.' !important;
    height: 3px !important;
    overflow: hidden !important;
    width: 70px;
    background-color: #000 !important;
    text-indent: 100% !important;
    position: absolute !important;
    /*bottom: 12px !important;*/
  }

  .brandsNavLl {
    margin-top: 15px;
    display: inline-block;
    vertical-align: top;
  }

  .brandsNavElement {
    letter-spacing: 23px;
    cursor: pointer;
    font-size: 13px !important;
    color: #848484 !important;


  }
  .brands:hover {
    text-decoration: underline !important;
  }
  .brandsDetail {
    margin-top: 30px;
  }

  .brandsDetailUl {
  }

  .brandsDetailLi {
    vertical-align: top;
    min-width: 300px;
    overflow: hidden;
  }

  .brandsDetailElement {
    float: left;
    width: 25%;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .merchantCategoryDetails {
    letter-spacing: 0.1px !important;
    white-space: nowrap !important;
    display: block !important;
    line-height: 24px !important;
    text-transform: capitalize !important;
    color: #666 !important;
    margin-bottom: 2px;
    cursor: pointer;
  }
  .merchantCategoryDetails:hover {
    text-decoration: underline !important;
  }
  .merchantcategory {
    border: none !important;
  }
  .selected {
    color: #333;
    font-weight: bold;
  }
  .tagdiv{
    width: 100% !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
    float: left !important;
    clear: both !important;
  }
  .goTop{
    width:5%;
    float: right;
    vertical-align: middle;
    color: #555555;
    cursor: pointer;
  }
  .detailtag {
    font-size: 15px !important;
    letter-spacing: 0.1px !important;
    color: #333 !important;
    display: inline-block !important;
  }
  .prohibit {
    color: #ccc !important;
    cursor: default;
  }
  @media screen and (min-width: 769px) {
    .brandsToggle {
      width: 420px;
    }

  }
  @media screen and (max-width: 769px) {
    .lg {
      display: none !important;
    }
    .sm {
      display: block !important;
    }
    .contioner {
      margin-top: 100px;
      padding-left: 20px;
      .brandsToggle {
        right: -4%;
        top: -50px;
      }

      .brandsDetailElement {
        float: none;
        width: 100%;
      }
      .brandsNavUl {
        position: absolute;
        right: -40%;


        .brandsNavLl {
          display: block !important;
          text-align: center;
          margin-top: 8px;

          .brandsNavElement {

          }
        }
      }

    }
  }
  @media screen and (max-width:414px) {
    .contioner {
      .brandsToggle {
        right: -32%;
      }
    }
  }
  @media screen and (max-width:375px) {
    .contioner {
      .brandsToggle {
        right: -42%;
      }
      .brandsNavUl {
        .brandsNavLl {
          margin-top: 5px;
        }
      }
    }
  }
  @media screen and (max-width:360px) {
    .contioner {
      .brandsToggle {
        right: -44%;
      }
      .brandsNavUl {
        .brandsNavLl {
          margin-top: 4px;
        }
      }
    }
  }
  @media screen and (max-width:320px) {
    .contioner {
      .brandsToggle {
        right: -43%;
        width: 310px;

        .orderToggle {
          font-size: 10px;
        }
      }
      .brandsNavUl {
        .brandsNavLl {
          margin-top: 2px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchant/merchantList.vue